import { ServiceItem, ZoneItem, Testimonial } from '../types';

export const SERVICES: ServiceItem[] = [
  {
    id: 'plumbing',
    title: {
      fr: 'Plomberie & Sanitaire',
      nl: 'Loodgieterij & Sanitair',
      en: 'Plumbing & Sanitary'
    },
    shortDesc: {
      fr: 'Dépannage express, réparation de fuites, robinetterie et rénovation complète de salle de bain en Belgique.',
      nl: 'Dringende herstellingen, lekdetectie, kraanwerk en volledige badkamerrenovatie in België.',
      en: 'Express repairs, leak detection, taps, and complete bathroom renovation across Belgium.'
    },
    fullDesc: {
      fr: 'Nos plombiers qualifiés interviennent 24h/24 et 7j/7 pour tous vos problèmes de plomberie et d\'installation sanitaire. De la recherche de fuite non destructive au raccordement de sanitaires et à la rénovation de salles de bains aux normes belges.',
      nl: 'Onze gekwalificeerde loodgieters staan 24/7 klaar voor al uw loodgieterij en sanitair. Van niet-destructieve lekdetectie tot sanitair aansluiten en badkamerrenovatie volgens de Belgische normen.',
      en: 'Our qualified plumbers are available 24/7 for all your plumbing and sanitary needs. From non-destructive leak detection to sanitary connections and bathroom renovations meeting Belgian standards.'
    },
    icon: 'Wrench',
    priceStartingAt: '',
    features: {
      fr: [
        'Dépannage plomberie express en 30 min',
        'Recherche de fuite avec caméra thermique & gaz traceur',
        'Réparation et remplacement de tuyauterie (cuivre, multicouche, PVC)',
        'Installation et raccordement de sanitaires (WC, douche, baignoire, évier)',
        'Rénovation complète de salle de bain clé en main'
      ],
      nl: [
        'Dringende loodgieterdienst binnen 30 min',
        'Lekdetectie met thermische camera & traceergas',
        'Herstelling en vervanging van leidingen (koper, alpex, pvc)',
        'Installatie van sanitair (toilet, douche, bad, lavabo)',
        'Volledige badkamerrenovatie sleutelklaar'
      ],
      en: [
        'Express plumbing repair within 30 mins',
        'Leak detection with thermal camera & tracer gas',
        'Pipe repair and replacement (copper, multilayer, PVC)',
        'Sanitary installation (toilet, shower, bath, sink)',
        'Turnkey complete bathroom renovation'
      ]
    },
    keywords: [
      'plombier Belgique', 'dépannage plomberie express', 'rénovation salle de bain',
      'loodgieter België', 'dringende loodgieter', 'badkamerrenovatie',
      'emergency plumber Belgium', 'plumbing repair', 'bathroom fitting'
    ]
  },
  {
    id: 'heating',
    title: {
      fr: 'Chauffage & Chaudières',
      nl: 'Verwarming & Ketels',
      en: 'Heating & Boilers'
    },
    shortDesc: {
      fr: 'Entretien légal chaudière gaz, installation de chauffage central et dépannage urgent par chauffagistes agréés.',
      nl: 'Wettelijk onderhoud gasketel, installatie centrale verwarming en herstelling door erkende technici.',
      en: 'Legal boiler service (gas), central heating installation, and urgent repairs by certified engineers.'
    },
    fullDesc: {
      fr: 'Experts en chauffage central en Belgique. Nous assurons l\'entretien périodique obligatoire de votre chaudière gaz (Bruxelles, Wallonie, Flandre), le dépannage de radiateurs, la pose de pompes à chaleur et thermostats connectés.',
      nl: 'Experts in centrale verwarming in België. Wij verzorgen het verplichte periodieke onderhoud van uw gasketel, radiatorherstellingen en warmtepompen.',
      en: 'Central heating experts in Belgium. We provide mandatory periodic servicing for gas boilers, radiator repairs, heat pump installations, and smart thermostats.'
    },
    icon: 'Flame',
    priceStartingAt: {
      fr: 'Entretien : 125 € HTVA | Dépannage : 205 € HTVA',
      nl: 'Onderhoud: 125 € ex. BTW | Herstelling: 205 € ex. BTW',
      en: 'Maintenance: 125 € ex. VAT | Repair: 205 € ex. VAT'
    },
    fixedPrices: {
      fr: [
        { title: 'Entretien Chaudière Gaz', price: '125 € HTVA', note: 'Attestation légale incluse' },
        { title: 'Dépannage Chaudière', price: '205 € HTVA', note: 'Main d\'œuvre (hors pièces)' }
      ],
      nl: [
        { title: 'Onderhoud Gasketel', price: '125 € ex. BTW', note: 'Officieel attest inbegrepen' },
        { title: 'Herstelling Verwarmingsketel', price: '205 € ex. BTW', note: 'Werkuren (excl. onderdelen)' }
      ],
      en: [
        { title: 'Gas Boiler Servicing', price: '125 € ex. VAT', note: 'Legal certificate included' },
        { title: 'Boiler Repair & Breakdown', price: '205 € ex. VAT', note: 'Labor rate (excl. parts)' }
      ]
    },
    features: {
      fr: [
        'Entretien légal chaudière gaz avec attestation officielle (Prix fixe : 125 € HTVA)',
        'Dépannage chaudière en panne 7j/7 (Prix fixe : 205 € HTVA main d\'œuvre, hors pièces)',
        'Installation de chauffage central et radiateurs haute efficacité',
        'Installation de chauffage au sol (plancher chauffant)',
        'Pose de thermostats intelligents et régulation climatique',
        'Désambouage de chauffage',
        'Installation et entretien de pompe à chaleur',
        'Attestation de réception de l\'installation'
      ],
      nl: [
        'Wettelijk onderhoud gasketel met officieel attest (Vaste prijs: 125 € ex. BTW)',
        'Herstelling van defecte verwarmingsketels 7j/7 (Vaste prijs: 205 € ex. BTW werkuren, excl. onderdelen)',
        'Installatie centrale verwarming en hoogrendementsradiatoren',
        'Installatie van vloerverwarming',
        'Plaatsing slimme thermostaten en weersafhankelijke regeling',
        'Ontkalking en chemische reiniging van CV-circuits',
        'Installatie en onderhoud van warmtepompen',
        'Attest van ontvangst van de installatie'
      ],
      en: [
        'Legal gas boiler maintenance with official certification (Fixed price: 125 € ex. VAT)',
        'Emergency boiler repair 7 days a week (Fixed price: 205 € ex. VAT labor, excl. parts)',
        'Central heating and high-efficiency radiator installation',
        'Underfloor heating installation',
        'Smart thermostat setup and weather compensation',
        'Power flushing and descaling of heating circuits',
        'Heat pump installation and maintenance',
        'Installation acceptance certificate'
      ]
    },
    keywords: [
      'chauffagiste Bruxelles', 'entretien chaudière gaz', 'installation chauffage central',
      'onderhoud gasketel', 'installateur centrale verwarming', 'verwarmingsketel herstelling',
      'heating engineer Brussels', 'boiler installation and maintenance'
    ]
  },
  {
    id: 'unblocking',
    title: {
      fr: 'Débouchage Urgent 24/7',
      nl: 'Dringende Ontstopping 24/7',
      en: 'Emergency Drain Unblocking 24/7'
    },
    shortDesc: {
      fr: 'Débouchage canalisation, WC, évier, inspection caméra haute définition et vidange d\'égouts en Belgique.',
      nl: 'Ontstopping van riolering, toilet, gootsteen, HD camera-inspectie en ruiming in België.',
      en: 'Drain unblocking for toilets, sinks, sewers, high-definition camera inspection across Belgium.'
    },
    fullDesc: {
      fr: 'Une canalisation bouchée, un WC engorgé ou un refoulement d\'égout ? API HEAT déploie ses équipes d\'experts en débouchage haute pression dans toute la Belgique pour un résultat immédiat et garanti.',
      nl: 'Een verstopte afvoer, overstroming of slechtlopend toilet? API HEAT zet hogedrukwagens in door heel België voor een snelle en gegarandeerde oplossing.',
      en: 'A blocked pipe, clogged toilet, or sewer backup? API HEAT deploys high-pressure unblocking teams across all of Belgium for an immediate guaranteed fix.'
    },
    icon: 'ShieldAlert',
    priceStartingAt: '',
    features: {
      fr: [
        'Débouchage mécanique et haute pression (hydrocurage)',
        'Inspection par caméra endoscopique des canalisations et recherche de cassures',
        'Débouchage de WC, éviers, douches, colonnes d\'immeuble',
        'Curage et nettoyage d\'égouts et fosses septiques',
        'Intervention d\'urgence anti-refoulement 24/7'
      ],
      nl: [
        'Mechanische en hogedruk ontstoppingsdienst (hydro-jetting)',
        'Endoscopische camera-inspectie van leidingen en breukdetectie',
        'Ontstoppen van wc, gootsteen, douche en standleidingen',
        'Reinigen en ruimen van riolen en septische putten',
        'Dringende interventie bij wateroverlast 24/7'
      ],
      en: [
        'Mechanical and high-pressure drain jetting',
        'Endoscopic HD camera inspection of pipes and defect detection',
        'Clearing blocked toilets, sinks, showers, and stack pipes',
        'Sewer cleaning and septic tank maintenance',
        '24/7 emergency backflow prevention response'
      ]
    },
    keywords: [
      'débouchage canalisation urgence', 'débouchage WC Belgique', 'inspection caméra canalisation', 'vidange fosse septique',
      'ontstoppingsdienst België', 'wc ontstoppen', 'riool ontstoppen', 'camera-inspectie leidingen',
      'drain unblocking service Belgium', 'clogged toilet repair', 'sewer inspection'
    ]
  },
  {
    id: 'ventilation',
    title: {
      fr: 'Ventilation & VMC',
      nl: 'Ventilatie & VMC',
      en: 'Ventilation & Air Systems'
    },
    shortDesc: {
      fr: 'Installation, dépannage et entretien de systèmes de ventilation simple flux et double flux en Belgique.',
      nl: 'Installatie, herstelling en onderhoud van enkelvoudige en dubbele ventilatiesystemen in België.',
      en: 'Installation, repair, and maintenance of single-flow and double-flow ventilation systems across Belgium.'
    },
    fullDesc: {
      fr: 'Experts en ventilation résidentielle et tertiaire en Belgique. Nous assurons l\'installation, le dépannage et l\'entretien complet des appareils de ventilation simple flux et double flux pour garantir une qualité d\'air intérieur optimale.',
      nl: 'Experten in residentiële en tertiaire ventilatie in België. Wij verzorgen de installatie, herstelling en het onderhoud van ventilatiesystemen type enkelvoudige en dubbele flux voor een optimale binnenluchtkwaliteit.',
      en: 'Residential and commercial ventilation experts in Belgium. We provide professional installation, repair, and maintenance of single-flow and double-flow ventilation systems for optimal indoor air quality.'
    },
    icon: 'Wind',
    priceStartingAt: '',
    features: {
      fr: [
        'Installation de systèmes de ventilation simple flux et double flux',
        'Dépannage et réparation d\'appareils de ventilation en panne',
        'Entretien et nettoyage complet des appareils et gaines',
        'Équilibrage et mesure des débits d\'air',
        'Amélioration de la qualité de l\'air intérieur (QAI)'
      ],
      nl: [
        'Installatie van enkelvoudige en dubbele ventilatiesystemen',
        'Herstelling en depannage van defecte ventilatietoestellen',
        'Volledig onderhoud en reiniging van toestellen en kanalen',
        'Inregeling en debietmeting van luchtstromen',
        'Optimalisatie van de binnenluchtkwaliteit'
      ],
      en: [
        'Single-flow and double-flow ventilation system installation',
        'Emergency repair and troubleshooting of ventilation units',
        'Complete maintenance and cleaning of ventilation units and ducts',
        'Airflow balancing and measurement',
        'Indoor air quality (IAQ) optimization'
      ]
    },
    keywords: [
      'ventilation Belgique', 'VMC simple flux double flux', 'entretien ventilation',
      'ventilatie installatie', 'VMC onderhoud', 'ventilatiesysteem herstelling'
    ]
  },
  {
    id: 'water-softener',
    title: {
      fr: 'Adoucisseur d\'Eau',
      nl: 'Waterontharder',
      en: 'Water Softener'
    },
    shortDesc: {
      fr: 'Installation, réparation et remplacement d\'adoucisseurs d\'eau pour éliminer le calcaire en Belgique.',
      nl: 'Installatie, herstelling en vervanging van waterontharders tegen kalk in België.',
      en: 'Installation, repair, and replacement of water softeners to eliminate limescale across Belgium.'
    },
    fullDesc: {
      fr: 'Protégez vos installations et votre électroménager contre le calcaire. Nous assurons l\'installation professionnelle, la réparation et le remplacement d\'adoucisseurs d\'eau toutes marques en Belgique.',
      nl: 'Bescherm uw installaties en huishoudtoestellen tegen kalk. Wij verzorgen de professionele installatie, herstelling en vervanging van waterontharders van alle merken in België.',
      en: 'Protect your plumbing and appliances against limescale. We provide professional installation, repair, and replacement of water softeners of all brands across Belgium.'
    },
    icon: 'Droplets',
    priceStartingAt: '',
    features: {
      fr: [
        'Installation d\'adoucisseur d\'eau neuf sur mesure',
        'Dépannage et réparation d\'adoucisseur en panne toutes marques',
        'Remplacement d\'ancien adoucisseur d\'eau',
        'Réglage de la dureté de l\'eau (th) et mise en service',
        'Fourniture de sel régénérant et entretien préventif'
      ],
      nl: [
        'Installatie van een nieuwe waterontharder op maat',
        'Herstelling en depannage van waterontharders alle merken',
        'Vervanging van oude waterontharder',
        'Instelling van de waterhardheid en inbedrijfstelling',
        'Levering van regeneratiezout en preventief onderhoud'
      ],
      en: [
        'Custom water softener installation',
        'Repair and troubleshooting of all water softener brands',
        'Old water softener replacement',
        'Water hardness adjustment and commissioning',
        'Regenerating salt supply and preventive maintenance'
      ]
    },
    keywords: [
      'adoucisseur d\'eau Belgique', 'installation adoucisseur', 'réparation adoucisseur eau',
      'waterontharder installatie', 'waterontharder herstelling', 'water softener installation Belgium'
    ]
  }
];

export const BELGIAN_ZONES: ZoneItem[] = [
  // Bruxelles
  { code: '1000', name: 'Bruxelles / Brussel (Ville)', region: 'Brussels', avgResponseTime: '25 min', slug: 'bruxelles' },
  { code: '1050', name: 'Ixelles / Elsene', region: 'Brussels', avgResponseTime: '25 min', slug: 'ixelles' },
  { code: '1070', name: 'Anderlecht', region: 'Brussels', avgResponseTime: '20 min', slug: 'anderlecht' },
  { code: '1030', name: 'Schaerbeek / Schaarbeek', region: 'Brussels', avgResponseTime: '25 min', slug: 'schaerbeek' },
  { code: '1060', name: 'Saint-Gilles / Sint-Gillis', region: 'Brussels', avgResponseTime: '25 min', slug: 'saint-gilles' },
  { code: '1080', name: 'Molenbeek-Saint-Jean / Sint-Jans-Molenbeek', region: 'Brussels', avgResponseTime: '30 min', slug: 'molenbeek' },
  { code: '1200', name: 'Woluwe-Saint-Lambert / Sint-Lambrechts-Woluwe', region: 'Brussels', avgResponseTime: '30 min', slug: 'woluwe-saint-lambert' },
  { code: '1150', name: 'Woluwe-Saint-Pierre / Sint-Pieters-Woluwe', region: 'Brussels', avgResponseTime: '30 min', slug: 'woluwe-saint-pierre' },
  { code: '1180', name: 'Uccle / Ukkel', region: 'Brussels', avgResponseTime: '25 min', slug: 'uccle' },

  // Brabant Flamand & Ring (Vlaams-Brabant - Zone siège & intervention directe)
  { code: '1600', name: 'Sint-Pieters-Leeuw (Siège API HEAT)', region: 'Flanders', avgResponseTime: '15 min', slug: 'sint-pieters-leeuw' },
  { code: '1500', name: 'Halle (Hal)', region: 'Flanders', avgResponseTime: '20 min', slug: 'halle' },
  { code: '1650', name: 'Beersel', region: 'Flanders', avgResponseTime: '20 min', slug: 'beersel' },
  { code: '1700', name: 'Dilbeek', region: 'Flanders', avgResponseTime: '25 min', slug: 'dilbeek' },
  { code: '1800', name: 'Vilvoorde (Vilvorde)', region: 'Flanders', avgResponseTime: '25 min', slug: 'vilvoorde' },
  { code: '1930', name: 'Zaventem (Aéroport / Brussels Airport)', region: 'Flanders', avgResponseTime: '25 min', slug: 'zaventem' },
  { code: '1850', name: 'Grimbergen', region: 'Flanders', avgResponseTime: '25 min', slug: 'grimbergen' },
  { code: '1780', name: 'Wemmel', region: 'Flanders', avgResponseTime: '25 min', slug: 'wemmel' },
  { code: '3000', name: 'Leuven (Louvain)', region: 'Flanders', avgResponseTime: '30 min', slug: 'leuven' },
  { code: '3080', name: 'Tervuren', region: 'Flanders', avgResponseTime: '25 min', slug: 'tervuren' },
  { code: '1900', name: 'Overijse', region: 'Flanders', avgResponseTime: '25 min', slug: 'overijse' },
  { code: '1950', name: 'Kraainem', region: 'Flanders', avgResponseTime: '25 min', slug: 'kraainem' },
  { code: '1560', name: 'Hoeilaart', region: 'Flanders', avgResponseTime: '25 min', slug: 'hoeilaart' },
  { code: '1730', name: 'Asse', region: 'Flanders', avgResponseTime: '30 min', slug: 'asse' },

  // Grandes Métropoles Flamandes (Anvers, Flandre Orientale, Occidentale, Limbourg)
  { code: '2000', name: 'Antwerpen (Anvers - Centre & Port)', region: 'Flanders', avgResponseTime: '35 min', slug: 'antwerpen' },
  { code: '2800', name: 'Mechelen (Malines)', region: 'Flanders', avgResponseTime: '30 min', slug: 'mechelen' },
  { code: '9000', name: 'Gent (Gand)', region: 'Flanders', avgResponseTime: '35 min', slug: 'gent' },
  { code: '9300', name: 'Aalst (Alost)', region: 'Flanders', avgResponseTime: '30 min', slug: 'aalst' },
  { code: '9100', name: 'Sint-Niklaas (Saint-Nicolas)', region: 'Flanders', avgResponseTime: '35 min', slug: 'sint-niklaas' },
  { code: '8000', name: 'Brugge (Bruges)', region: 'Flanders', avgResponseTime: '40 min', slug: 'brugge' },
  { code: '8500', name: 'Kortrijk (Courtrai)', region: 'Flanders', avgResponseTime: '35 min', slug: 'kortrijk' },
  { code: '8800', name: 'Roeselare (Roulers)', region: 'Flanders', avgResponseTime: '40 min', slug: 'roeselare' },
  { code: '3500', name: 'Hasselt', region: 'Flanders', avgResponseTime: '40 min', slug: 'hasselt' },
  { code: '3600', name: 'Genk', region: 'Flanders', avgResponseTime: '40 min', slug: 'genk' },

  // Wallonie & Brabant Wallon
  { code: '1410', name: 'Waterloo', region: 'Wallonia', avgResponseTime: '25 min', slug: 'waterloo' },
  { code: '1420', name: 'Braine-l\'Alleud', region: 'Wallonia', avgResponseTime: '25 min', slug: 'braine-lalleud' },
  { code: '1300', name: 'Wavre (Waver)', region: 'Wallonia', avgResponseTime: '30 min', slug: 'wavre' },
  { code: '4000', name: 'Liège (Luik)', region: 'Wallonia', avgResponseTime: '35 min', slug: 'liege' },
  { code: '6000', name: 'Charleroi', region: 'Wallonia', avgResponseTime: '35 min', slug: 'charleroi' },
  { code: '5000', name: 'Namur (Namen)', region: 'Wallonia', avgResponseTime: '35 min', slug: 'namur' },
  { code: '7000', name: 'Mons (Bergen)', region: 'Wallonia', avgResponseTime: '35 min', slug: 'mons' },
  { code: '7100', name: 'La Louvière', region: 'Wallonia', avgResponseTime: '35 min', slug: 'la-louviere' }
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: '1',
    name: 'Jean-Luc D.',
    city: 'Bruxelles (Ixelles)',
    lang: 'fr',
    rating: 5,
    date: 'Il y a 2 jours',
    comment: 'Intervention ultra rapide un dimanche pour une fuite d’eau importante sous l’évier. Plombier très professionnel, courtois et facture claire sans mauvaise surprise.',
    service: 'Plomberie & Sanitaire'
  },
  {
    id: '2',
    name: 'An V.',
    city: 'Antwerpen',
    lang: 'nl',
    rating: 5,
    date: 'Vorige week',
    comment: 'Jaarlijks onderhoud van onze gasketel laten uitvoeren. Stipt op tijd, attest meteen in de mailbox en zeer vriendelijke technieker. Absolute aanrader!',
    service: 'Verwarming & Ketels'
  },
  {
    id: '3',
    name: 'Marc P.',
    city: 'Liège',
    lang: 'fr',
    rating: 5,
    date: 'Il y a 3 jours',
    comment: 'Canalisation complètement bouchée à 21h. L’équipe d’API HEAT est intervenue en moins de 40 minutes avec leur camion haute pression. Problème réglé net.',
    service: 'Débouchage Urgent'
  },
  {
    id: '4',
    name: 'Sarah M.',
    city: 'Woluwe-Saint-Pierre',
    lang: 'en',
    rating: 5,
    date: 'Yesterday',
    comment: 'Top service! Emergency boiler repair in Brussels during winter. The engineer spoke fluent English and fixed our heating within the hour.',
    service: 'Heating & Boilers'
  }
];

export const TRANSLATIONS = {
  fr: {
    brandName: 'API HEAT',
    tagline: 'Plomberie, Chauffage & Débouchage Express en Belgique',
    emergencyBanner: 'Urgences 24h/24 & 7j/7 partout en Belgique :',
    callUs: 'Appeler maintenant',
    navHome: 'Accueil',
    navServices: 'Nos Services',
    navZones: 'Zones d\'Intervention',
    navAbout: 'À Propos',
    navContact: 'Contact & Devis',
    navSchema: 'Inspecteur SEO & Schema.org',
    
    heroTitle: 'Experts en Plomberie, Chauffage et Débouchage 24/7 en Belgique',
    heroSub: 'Intervention rapide en 30 minutes à Bruxelles, en Wallonie et en Flandre. Techniciens agréés, devis gratuit et transparent, garantie 100% satisfaction.',
    ctaEstimate: 'Demander un devis gratuit',
    ctaCallEmergency: 'Urgence 24/7',
    
    featuresTitle: 'Pourquoi choisir API HEAT ?',
    feat1Title: 'Intervention en 30 min',
    feat1Desc: 'Équipes mobiles basées dans toutes les grandes villes belges pour arriver chez vous en un temps record.',
    feat2Title: 'Techniciens Agréés',
    feat2Desc: 'Experts certifiés et agréés par toutes les grandes marques de chaudières.',
    feat3Title: 'Tarifs Transparents',
    feat3Desc: 'Pas de mauvaise surprise : devis clair validé avant chaque intervention, prix fixes et compétitifs.',
    feat4Title: 'Garantie Pièces & Main d\'Œuvre',
    feat4Desc: 'Toutes nos installations de plomberie et de chauffage bénéficient d\'une garantie complète sur les pièces et la main d\'œuvre.',

    servicesSectionTitle: 'Nos Prestations Professionnelles',
    servicesSectionSub: 'Des solutions sur-mesure pour les particuliers et les professionnels partout en Belgique.',
    startingAt: 'À partir de',
    details: 'En savoir plus',
    bookService: 'Réserver ce service',

    zonesSectionTitle: 'Zones d\'Intervention 24/7 en Belgique',
    zonesSectionSub: 'Entrez votre code postal ou sélectionnez votre commune pour vérifier notre temps de trajet estimé.',
    searchPlaceholder: 'Rechercher une commune ou un code postal (ex: 1000, Anvers, Liège...)',
    regionBrussels: 'Bruxelles-Capitale',
    regionFlanders: 'Flandre',
    regionWallonia: 'Wallonie',
    avgTime: 'Temps d\'intervention moyen :',

    aboutSectionTitle: 'À Propos d\'API HEAT',
    aboutLead: 'Leader belge des services d\'urgence technique et de rénovation énergétique.',
    aboutText1: 'Fondée à Bruxelles et active dans tout le pays (Flandre, Wallonie, Bruxelles), API HEAT regroupe des artisans plombiers et chauffagistes passionnés et diplômés.',
    aboutText2: 'Nous combinons une réactivité 24/7 pour les urgences (fuites, pannes de chauffage, engorgements) avec un savoir-faire d’excellence pour vos installations sanitaires et chaudières à haut rendement.',
    certifications: 'Nos Certifications & Agréations',

    testimonialsTitle: 'Ce que disent nos clients en Belgique',
    testimonialsSub: 'Plus de 4 500 interventions réussies avec une note moyenne de 4.9/5.',

    contactSectionTitle: 'Contactez-nous ou Demandez un Devis Gratuit',
    contactSub: 'Réponse rapide garantie en moins de 15 minutes par notre équipe.',
    formName: 'Nom et Prénom',
    formPhone: 'Téléphone (GSM)',
    formEmail: 'Adresse Email',
    formPostal: 'Code Postal & Ville',
    formService: 'Service concerné',
    formIsEmergency: '⚠️ C\'est une urgence (intervention immédiate souhaitée)',
    formMessage: 'Décrivez votre problème ou projet',
    formSubmit: 'Envoyer la demande',
    formSuccess: 'Votre demande a bien été envoyée ! Un technicien API HEAT va vous contacter immédiatement.',
    
    footerRights: 'Tous droits réservés. API HEAT - ELF DISTRICT 🔴🔵 | TVA: BE0794.514.033 | Contact: Ilias El Filali.',
    footerCol1: 'Services',
    footerCol2: 'Régions',
    footerCol3: 'Contact',
    footerCol4: 'Légal & SEO',
    
    schemaTitle: 'Inspecteur de Données Structurées (SEO Schema.org)',
    schemaSub: 'Voici les données JSON-LD intégrées à notre site pour maximiser notre visibilité sur Google Belgique (LocalBusiness & Plumber).',
    close: 'Fermer',
    copyJson: 'Copier le code JSON',

    heroBadge1Title: 'Plomberie & Fuite',
    heroBadge1Sub: 'Urgence 24/7 & Sanitaire',
    heroBadge2Title: 'Chauffage & Chaudières',
    heroBadge2Sub: 'Entretien & Dépannage 24/7',
    heroBadge3Title: 'Débouchage & Égout',
    heroBadge3Sub: 'Hydrocurage & Caméra HD'
  },
  nl: {
    brandName: 'API HEAT',
    tagline: 'Loodgieterij, Verwarming & Dringende Ontstopping in België',
    emergencyBanner: 'Dringende bijstand 24/7 in heel België:',
    callUs: 'Bel nu',
    navHome: 'Startpagina',
    navServices: 'Onze Diensten',
    navZones: 'Interventiegebieden',
    navAbout: 'Over Ons',
    navContact: 'Contact & Offerte',
    navSchema: 'SEO & Schema.org Inspector',

    heroTitle: 'Experts in Loodgieterij, Verwarming en Ontstopping 24/7 in België',
    heroSub: 'Snelle interventie binnen 30 minuten in Brussel, Wallonië en Vlaanderen. Gecertificeerde technici, gratis en transparante offerte, 100% tevredenheidsgarantie.',
    ctaEstimate: 'Gratis offerte aanvragen',
    ctaCallEmergency: '24/7 Nooddienst',

    servicesSectionTitle: 'Onze Professionele Diensten',
    servicesSectionSub: 'Oplossingen op maat voor particulieren en bedrijven in heel België.',
    startingAt: 'Vanaf',
    details: 'Meer info',
    bookService: 'Dienst boeken',

    zonesSectionTitle: 'Interventiegebieden 24/7 in België',
    zonesSectionSub: 'Geef uw postcode in of kies uw gemeente om onze verwachte aankomsttijd te controleren.',
    searchPlaceholder: 'Zoek gemeente of postcode (bijv. 1000, Antwerpen, Gent...)',
    regionBrussels: 'Brussels Hoofdstedelijk Gewest',
    regionFlanders: 'Vlaanderen',
    regionWallonia: 'Wallonië',
    avgTime: 'Gemiddelde interventietijd:',

    aboutSectionTitle: 'Over API HEAT',
    aboutLead: 'Belgische marktleider in technische nooddiensten en energierenovatie.',
    aboutText1: 'Opgericht in Brussel en actief in het hele land (Vlaanderen, Wallonië, Brussel), verenigt API HEAT gepassioneerde en gediplomeerde loodgieters en verwarmingstechnici.',
    aboutText2: 'Wij combineren een 24/7 beschikbaarheid voor noodgevallen (lekken, verwarmingsstoringen, verstoppingen) met uitmuntend vakmanschap voor al uw sanitair en hoogrendementsketels.',
    certifications: 'Onze Certificeringen & Erkenningen',

    testimonialsTitle: 'Wat onze klanten in België zeggen',
    testimonialsSub: 'Meer dan 4.500 geslaagde interventies met een gemiddelde score van 4.9/5.',

    contactSectionTitle: 'Contacteer ons of vraag een gratis offerte',
    contactSub: 'Snelle reactie gegarandeerd binnen 15 minuten door ons team.',
    formName: 'Voor- en achternaam',
    formPhone: 'Telefoonnummer (GSM)',
    formEmail: 'E-mailadres',
    formPostal: 'Postcode & Stad',
    formService: 'Geselecteerde dienst',
    formIsEmergency: '⚠️ Dit is een noodgeval (onmiddellijke interventie gewenst)',
    formMessage: 'Beschrijf uw probleem of project',
    formSubmit: 'Verstuur aanvraag',
    formSuccess: 'Uw aanvraag is succesvol verzonden! Een API HEAT technieker neemt direct contact met u op.',

    footerRights: 'Alle rechten voorbehouden. API HEAT - ELF DISTRICT 🔴🔵 | BTW: BE0794.514.033 | Contact: Ilias El Filali.',
    footerCol1: 'Diensten',
    footerCol2: 'Regio\'s',
    footerCol3: 'Contact',
    footerCol4: 'Juridisch & SEO',

    schemaTitle: 'Gestructureerde Data Inspecteur (SEO Schema.org)',
    schemaSub: 'Hier zijn de JSON-LD gegevens geïntegreerd in onze website om onze zichtbaarheid op Google België te maximaliseren.',
    close: 'Sluiten',
    copyJson: 'Kopieer JSON code',

    heroBadge1Title: 'Loodgieterij & Lek',
    heroBadge1Sub: '24/7 Nooddienst & Sanitair',
    heroBadge2Title: 'Verwarming & Ketels',
    heroBadge2Sub: 'Onderhoud & Herstelling 24/7',
    heroBadge3Title: 'Ontstopping & Riool',
    heroBadge3Sub: 'Rioolreiniging & HD Camera',

    featuresTitle: 'Waarom kiezen voor API HEAT?',
    feat1Title: 'Interventie in 30 min',
    feat1Desc: 'Mobiele teams gestationeerd in alle grote Belgische steden om in recordtijd ter plaatse te zijn.',
    feat2Title: 'Erkende Technici',
    feat2Desc: 'Gecertificeerde experts, erkend door alle grote gasketelmerken.',
    feat3Title: 'Transparante Prijzen',
    feat3Desc: 'Geen verrassingen: duidelijke offerte vooraf goedgekeurd, vaste en competitieve prijzen.',
    feat4Title: 'Kwaliteitsgarantie',
    feat4Desc: 'Al onze installaties genieten van een volledige garantie op onderdelen en uren.'
  },
  en: {
    brandName: 'API HEAT',
    tagline: 'Plumbing, Heating & Express Drain Unblocking in Belgium',
    emergencyBanner: '24/7 Emergency Dispatch Across Belgium:',
    callUs: 'Call Now',
    navHome: 'Home',
    navServices: 'Our Services',
    navZones: 'Service Areas',
    navAbout: 'About Us',
    navContact: 'Contact & Quote',
    navSchema: 'SEO & Schema.org Inspector',

    heroTitle: 'Expert Plumbing, Heating & Unblocking Services 24/7 in Belgium',
    heroSub: 'Rapid response within 30 minutes in Brussels, Flanders, and Wallonia. Certified engineers, free transparent estimates, 100% satisfaction guarantee.',
    ctaEstimate: 'Request Free Quote',
    ctaCallEmergency: '24/7 Emergency',

    servicesSectionTitle: 'Our Professional Services',
    servicesSectionSub: 'Tailored solutions for homes and businesses across Belgium.',
    startingAt: 'Starting at',
    details: 'Learn more',
    bookService: 'Book Service',

    zonesSectionTitle: '24/7 Service Areas Across Belgium',
    zonesSectionSub: 'Enter your postal code or select your city to check our estimated arrival time.',
    searchPlaceholder: 'Search city or postal code (e.g., 1000, Antwerp, Liège...)',
    regionBrussels: 'Brussels Capital',
    regionFlanders: 'Flanders',
    regionWallonia: 'Wallonia',
    avgTime: 'Average response time:',

    aboutSectionTitle: 'About API HEAT',
    aboutLead: 'Belgium’s leading technical emergency and energy renovation provider.',
    aboutText1: 'Founded in Brussels and active nationwide (Flanders, Wallonia, Brussels), API HEAT brings together skilled and certified plumbing and heating specialists.',
    aboutText2: 'We combine 24/7 emergency dispatch for leaks, boiler breakdowns, and blocked drains with top-tier craftsmanship for sanitary installations and high-efficiency heating.',
    certifications: 'Our Certifications & Accreditations',

    testimonialsTitle: 'What Our Clients in Belgium Say',
    testimonialsSub: 'Over 4,500 successful interventions with an average 4.9/5 rating.',

    contactSectionTitle: 'Contact Us or Request a Free Quote',
    contactSub: 'Fast response guaranteed within 15 minutes by our support team.',
    formName: 'Full Name',
    formPhone: 'Phone Number (Mobile)',
    formEmail: 'Email Address',
    formPostal: 'Postal Code & City',
    formService: 'Required Service',
    formIsEmergency: '⚠️ This is an emergency (immediate dispatch requested)',
    formMessage: 'Describe your issue or project',
    formSubmit: 'Submit Request',
    formSuccess: 'Your request has been successfully sent! An API HEAT technician will contact you immediately.',

    footerRights: 'All rights reserved. API HEAT - ELF DISTRICT 🔴🔵 | VAT: BE0794.514.033 | Contact: Ilias El Filali.',
    footerCol1: 'Services',
    footerCol2: 'Regions',
    footerCol3: 'Contact',
    footerCol4: 'Legal & SEO',

    schemaTitle: 'Structured Data Inspector (SEO Schema.org)',
    schemaSub: 'Here is the JSON-LD data embedded in our website to maximize visibility on Google Belgium (LocalBusiness & Plumber).',
    close: 'Close',
    copyJson: 'Copy JSON Code',

    heroBadge1Title: 'Plumbing & Leak',
    heroBadge1Sub: '24/7 Emergency & Sanitary',
    heroBadge2Title: 'Heating & Boilers',
    heroBadge2Sub: 'Maintenance & Repair 24/7',
    heroBadge3Title: 'Drain Unblocking & Sewer',
    heroBadge3Sub: 'Hydro-jetting & HD Camera',

    featuresTitle: 'Why Choose API HEAT?',
    feat1Title: '30-Min Response Time',
    feat1Desc: 'Mobile teams based in all major Belgian cities to arrive at your door in record time.',
    feat2Title: 'Certified Technicians',
    feat2Desc: 'Certified experts approved by all major boiler brands.',
    feat3Title: 'Transparent Pricing',
    feat3Desc: 'No surprises: clear quote approved before any work begins, fixed and competitive rates.',
    feat4Title: 'Quality & Parts Warranty',
    feat4Desc: 'All our installations benefit from a complete warranty on parts and labor.'
  }
};
